// extracted by mini-css-extract-plugin
module.exports = {"headerMenu":"Header_headerMenu__2H632","headerLogo":"Header_headerLogo__3NAQW"};